<template>
  <div class="payment">
    <h2>Formulario de pago</h2>
    <div class="payment-form form mt-3">
      <div>
        <div class="d-flex justify-content-center row">
          <div class="form--group col-6 col-sm-4">
            <label for="_rsvnro">Número de reserva</label>
            <div class="form--input">
              <input
                autocomplete="off"
                type="text"
                class="form--input"
                id="_rsvnro"
                v-model="rsvnro"
              >
            </div>
          </div>
          <div class="form--group col-6 col-sm-4">
            <label for="_rsvnro">Monto</label>
            <div class="form--input">
              <cleave
                @input="set_amount"
                :value="amount"
                :options="{ numeral: true, prefix: '$', delimiter: '', numeralPositiveOnly: true, rawValueTrimPrefix: true }"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2 mt-3">
          <div class="form--group col-12 col-sm-4">
            <span>Forma de pago</span>
            <label
              for="_method"
              class="form--select"
            >
              <span class="form--select--span">{{ method ? method.name : 'Seleccione una forma de pago' }}</span>
              <select
                id="_method"
                v-model="method"
              >
                <option
                  v-for="(name, type) in ['TARJETA DE CREDITO', 'AHORA 3, 6, 12 y 18']"
                  :key="type"
                  :value="{ name, type }"
                >{{ name }}</option>
              </select>
            </label>
          </div>
          <div
            class="form--group col-6 col-sm-3"
            v-if="method"
          >
            <span>Proveedor</span>
            <label
              for="_provider"
              class="form--select"
            >
              <span class="form--select--span">{{ provider ? provider : 'Seleccione un proveedor' }}</span>
              <select
                id="_provider"
                v-model="provider"
              >
                <option
                  v-for="c in $store.state.financing
                    .filter(a => a.type == method.type)
                    .map(a => a.provider)
                    .filter((a, b, self) => self.indexOf(a) === b)"
                  :key="c"
                  :value="c"
                >{{ c }}</option>
              </select>
            </label>
          </div>
          <div
            class="form--group col-6 col-sm-5"
            v-if="method && provider && amount"
          >
            <span>Cuotas</span>
            <label
              for="_dues"
              class="form--select"
            >
              <span class="form--select--span">{{
                financing ? financing.dues + ' de $' + total.dues + ' ($' + total.amount + ')' : 'Seleccione una opcion'
              }}</span>
              <select
                id="_dues"
                v-model="financing"
              >
                <option
                  v-for="option in financings"
                  :key="option.id"
                  :value="option"
                >{{ option.dues }} de ${{ option.amount }} (${{ option.total }})</option>
              </select>
            </label>
          </div>
        </div>
      </div>
      <div>
        <p>Completar los siguientes campos con los datos del <strong>titular de la tarjeta</strong>.</p>
        <div class="row">
          <div class="form--group col-12 col-sm-6">
            <label for="_card_holder_name">Nombre</label>
            <div class="form--input">
              <input
                autocomplete="off"
                type="text"
                class="form--input"
                id="_card_holder_name"
                v-model="card_holder_name"
              >
            </div>
          </div>
          <div class="form--group col-12 col-sm-6">
            <label for="_email">Email</label>
            <div class="form--input">
              <input
                autocomplete="off"
                type="text"
                class="form--input"
                id="_email"
                v-model="email"
              >
            </div>
          </div>
          <div class="form--group col-6 col-sm-4">
            <label for="_card_holder_doc_number">Dni</label>
            <div class="form--input">
              <input
                autocomplete="off"
                type="text"
                class="form--input"
                id="_card_holder_doc_number"
                v-model="card_holder_doc_number"
              >
            </div>
          </div>
          <div class="form--group col-6 col-sm-4">
            <label for="_borndate">Fecha de nacimiento</label>
            <div class="form--input">
              <cleave
                v-model="borndate"
                :options="{ date: true, datePattern: ['d', 'm', 'Y'] }"
                class="form-control"
              />
            </div>
          </div>
          <div class="form--group col-12 col-sm-4">
            <label for="_address">Domicilio</label>
            <div class="form--input">
              <input
                autocomplete="off"
                type="text"
                class="form--input"
                id="_address"
                v-model="address"
              >
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="form--group col-12 col-sm-7">
            <label for="_card_number">Tarjeta</label>
            <div class="form--input">
              <cleave
                ref="number"
                id="_card_number"
                v-model="card_number"
                :options="{ creditCard: true, onValueChanged: e => (card.number = e.target.value) }"
                class="form-control"
              />
            </div>
          </div>
          <div class="form--group col-6 col-sm-3">
            <label for="_vto">Vencimiento</label>
            <div class="form--input">
              <cleave
                ref="vto"
                id="_vto"
                :value="card.expiration"
                :options="{ date: true, datePattern: ['m', 'y'], onValueChanged: e => set_expiration(e.target) }"
                class="form-control"
              />
            </div>
          </div>
          <div class="form--group col-6 col-sm-2">
            <label for="_cvc">CVC</label>
            <div class="form--input">
              <cleave
                v-model="security_code"
                id="_cvc"
                :options="{ numeral: true, blocks: [3] }"
                class="form-control"
                maxlength="3"
              />
            </div>
          </div>
        </div>
        <div class="text-center mt-3">
          <card
            :number="card.number"
            :bank="provider"
            :name="(card_holder_name || '').toUpperCase()"
            :date="card.expiration"
            :code="security_code"
          />
        </div>
        <div class="form--btns">
          <btn
            color="violet"
            size="sm"
            class="col-4"
            @click.prevent="pay"
            v-if="ok && !$store.state.loading"
          >
            PAGAR
          </btn>
        </div>
      </div>
    </div>
    <form
      method="post"
      ref="form"
    >
      <input
        type="hidden"
        data-decidir="card_number"
        :value="card_number"
      >
      <input
        type="hidden"
        data-decidir="security_code"
        :value="security_code"
      >
      <input
        type="hidden"
        data-decidir="card_expiration_month"
        :value="card_expiration_month"
      >
      <input
        type="hidden"
        data-decidir="card_expiration_year"
        :value="card_expiration_year"
      >
      <input
        type="hidden"
        data-decidir="card_holder_name"
        :value="card_holder_name"
      >
      <input
        type="hidden"
        data-decidir="card_holder_doc_type"
        :value="card_holder_doc_type"
      >
      <input
        type="hidden"
        data-decidir="card_holder_doc_number"
        :value="card_holder_doc_number"
      >
    </form>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
import Card from './components/Card'
import swal from 'sweetalert2'
import axios from 'axios'
import { stringify } from 'qs'
import { API_PAYMENT_ENDPOINT_BASE } from '@/constans'
import { LOADING, FINANCING } from '@/store/mutations'

var ERRORS = {
  empty_card_number: 'El número de tarjeta es requerido.',
  empty_card_holder_name: 'El nombre es requerido.',
  nan_card_number: 'El número de tarjeta debe ser solo numeros.',
  invalid_card_number: 'El número de tarjeta es invalido.',
  invalid_expiry_date: 'El Vencimiento de tarjeta es invalido.',
  invalid_param: 'Alguno de los parametros es invalido.'
}

function sdkResponseHandler (status, response) {
  if (status != 200 && status != 201) {
    var errors = response.error.reduce(
      (tmp, item) =>
        item.hasOwnProperty('error') && item.error.hasOwnProperty('type') && ERRORS.hasOwnProperty(item.error.type)
          ? tmp.concat([ERRORS[item.error.type]])
          : tmp,
      []
    )

    const html = errors.length ? errors.join('<br>') : ERRORS.invalid_param

    swal({ type: 'error', title: 'Ocurrio un error', html })

    this.$store.commit(LOADING, false)
  } else {
    axios
      .post(API_PAYMENT_ENDPOINT_BASE + '/pay', stringify({ ...this.$data, ...response }))
      .then(({ data }) => {
        swal.fire(data.msg, '', 'success').then(() => this.$router.push('/'))
      })
      .catch(({ response }) => {
        swal.fire('Error', response.data.msg, 'error')
      })
      .finally(() => this.$store.commit(LOADING, false))
  }
}

export default {
  components: { Btn, Card },
  props: ['reservation'],
  methods: {
    set_expiration ({ value }) {
      this.card.expiration = value
      this.card_expiration_month = value.split('/')[0]
      this.card_expiration_year = value.split('/')[1]
    },
    pay () {
      this.$store.commit(LOADING, true)
      window.DecidirSDK.createToken(this.$refs.form, sdkResponseHandler.bind(this))
    },
    set_amount (a) {
      this.amount = Number(a)
    }
  },
  data () {
    return {
      method: null,
      email: '',
      rsvnro: this.reservation.id,
      security_code: '',
      card_number: '',
      card_expiration_month: '',
      card_expiration_year: '',
      card_holder_name: '',
      card_holder_doc_type: 'dni',
      card_holder_doc_number: '',
      address: '',
      borndate: '',
      financing: null,
      provider: null,
      amount: this.reservation.price.final,
      card: {
        expiration: '',
        number: ''
      }
    }
  },
  watch: {
    method () {
      this.financing = null
      this.provider = null
    },
    provider () {
      this.financing = null
    }
  },
  computed: {
    total () {
      return {
        dues: ((this.amount + (this.financing.taxes / 100) * this.amount) / this.financing.dues).toFixed(2),
        amount: ((this.amount + (this.financing.taxes / 100) * this.amount) * 100) / 100
      }
    },
    financings () {
      return this.$store.state.financing
        .filter(opt => this.amount && opt.type == this.method.type && opt.provider == this.provider)
        .map(opt => {
          opt.amount = ((this.amount + (opt.taxes / 100) * this.amount) / opt.dues).toFixed(2)
          opt.total = ((this.amount + (opt.taxes / 100) * this.amount) * 100) / 100

          return opt
        })
        .sort((a, b) => a.dues - b.dues)
    },
    ok () {
      return Object.values(this.$data).every(e => e)
    }
  }
}
</script>
